"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpSearchDropdown: {
        fetchingInformation: 'Fetching Information, please wait a second',
    },
};
